import { Route, type LoaderFunctionArgs } from "react-router-dom";

import { queryClient } from "@/providers/QueryClient";
import { loadSearchTablePreferences } from "@/shared/domain/config/loaders/loadSearchTablePreferences";
import { makeFeatureFlagRedirectLoader } from "@/shared/routing/featureFlagRoute";

import { EventsPage } from "./EventsPage";

const gateLoader = makeFeatureFlagRedirectLoader(queryClient, {
  flagName: "release-feature-pages",
  redirectTo: "/search?target=events",
});

const preferencesLoader = loadSearchTablePreferences(
  queryClient,
  "event_search_table_preferences",
);

async function eventsListLoader(args: LoaderFunctionArgs) {
  // Gate first; if the flag is off the response is a redirect we must return
  // verbatim so the gated UI never mounts.
  const gateResult = await gateLoader(args);
  if (gateResult) {
    return gateResult;
  }
  return preferencesLoader(args);
}

export const EventsRoutes = () => [
  <Route key={"/"} index loader={eventsListLoader} element={<EventsPage />} />,
];
